import { useMutation } from "react-query";
import lunchService from "../services/lunchService";

const useGetLunchSessionByUserId = (onData) => {
  return useMutation(lunchService.getLunchSessionByUserId, {
    onSuccess: (data) => onData(data),
  });
};

const useCreateLunchSession = (onData) => {
  return useMutation(lunchService.createLunchSession, {
    onSuccess: (data) => onData(data),
  });
};

const useTodayLunchUsers = (onData) => {
  return useMutation(lunchService.todayLunchUsers, {
    onSuccess: (data) => onData(data),
  });
};

const lunchQueries = {
  useGetLunchSessionByUserId,
  useCreateLunchSession,
  useTodayLunchUsers
};

export default lunchQueries;
